exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ais-GeoSearch-map {\n    height: calc(100vh - 70px);\n}\n", ""]);

// exports
